/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useLocalStorage } from '../../Hooks/UseLocalStorage'
import toast from 'react-hot-toast'
const AuthContext = createContext()

// interface propType{
//     children:ReactChild
// }
// eslint-disable-next-line react/prop-types
export const AuthProvider = ({ children }) => {
  const location = useLocation()
  const [timer, setTimer] = useState(false)
  const currentPath = location.pathname
  // console.log('CUP', currentPath)
  const [user, setUser] = useLocalStorage('__session_polac_physical', null)
  const navigate = useNavigate()

  // call this function when you want to authenticate the user
  const login = async (data) => {
    setUser(data)
    navigate('/dashboard')
  }
  const timeout = () => {
    const storedData = localStorage.getItem('__session_polac_physical')
    const Dara = JSON.parse(storedData)
    const current = new Date().getTime()
    const Exp = Dara?.exp * 1000
    // const checkValue = new Date(Exp)
    // console.log('DD', { checkValue, current, Exp })

    if (current >= Exp) {
      // Immediately redirect to the login page WITHOUT reloading:
      setUser(null)
      navigate('/login?', { replace: true })
      toast.error({ message: 'Session Timeout', duration: 200 })
    }
  }

  const checkTimeout = () => {
    // const currentPath = window.location.pathname

    if (currentPath !== '/login' || currentPath !== '/') {
      // Use setImmediate to ensure that the timeout function is executed in the next event loop cycle
      setInterval(() => {
        timeout()
      }, 300000)
    }
  }

  // Trigger the initial checkTimeout when the component mounts
  useEffect(() => {
    checkTimeout()
  }, [user])

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null)
    navigate('/login', { replace: true })
  }

  const value = useMemo(() => ({ user, login, logout }),
    [user])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  return useContext(AuthContext)
}
